import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import LeadsAssignedService from '../../services/LeadsAssignedService';
import { Toast } from 'primereact/toast';
import AuthService from '../../services/AuthService';
import LeadService from '../../services/LeadService';
import RegisterUserService from '../../services/RegisterUserService';
import ToastService from '../../services/ToastService';
import { MdRepeat } from 'react-icons/md';
import { LEAD_STATUSES, PROPERTY_TYPES, getStatusStyle } from '../../constants/leadConstants';


function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function FilterDataDashboardList() {
  const { employeeId, fromDateParam, toDateParam } = useParams();
  const [LeadsAssigned, setLeadsAssigned] = useState([]);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState(''); 
  const toast = useRef(null);
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const queryParam = useQuery();
  const fromDate = new Date(fromDateParam);
  const toDate = new Date(toDateParam);
  const toastService = new ToastService(toast);
  const [userId, setUserId] = useState(AuthService.getLoggedInUserId());
  const clientId = AuthService.getLoggedInClientId();
  const [leadStatus, setLeadStatus]= useState([]);
  const [selectedStatus, setSelectedStatus] = useState(''); 
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const userRole = AuthService.getLoggedInRoleId(); 
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false); 
  const [selectedValue, setSelectedValue] = useState('');
  const [isEmployeeSelectedError, setIsEmployeeSelectedError] = useState(false);


  useEffect(() => {
    async function fetchLeadsAssigned() {
      try {
  
        const leadsassignedData = await LeadsAssignedService.getAllLeadsAssigned(userId, clientId);
        const sortedLeadsAssigned = (leadsassignedData || []).sort((a, b) => new Date(b.leadAssignedDate) - new Date(a.leadAssignedDate));
        setLeadsAssigned(sortedLeadsAssigned);
      } catch (error) {
        console.error('Error fetching leads assigned:', error);  
       // toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch leads assigned data' });
      }
    };

    fetchLeadsAssigned();
  }, [userId, clientId]); 
  

  const filteredLeadsAssigned = LeadsAssigned.filter((leadassigned) => {
    const statusMatches = selectedStatus ? leadassigned.leadStatusId === parseInt(selectedStatus) : true;

    const lead = leadassigned.lead;
    const leadNameMatches = lead ? 
        `${lead.firstName}`.toLowerCase().includes(globalSearchTerm.toLowerCase()) : false;
    const phoneNumberMatches = lead ? 
        lead.contactNumber.toLowerCase().includes(globalSearchTerm.toLowerCase()) : false;
    const emailMatches = lead ? 
        lead.email.toLowerCase().includes(globalSearchTerm.toLowerCase()) : false;

    const searchMatches = leadassigned.conversationComment &&
        leadassigned.conversationComment.toLowerCase().includes(globalSearchTerm.toLowerCase()) ||
        leadNameMatches || phoneNumberMatches || emailMatches;
     
    const clearTime = (date) => {
      const newDate = new Date(date);
      newDate.setHours(0, 0, 0, 0);
      return newDate;
      };
      const leadDate = clearTime(new Date(leadassigned.leadAssignedDate));
      const fromDateClear = fromDate ? clearTime(new Date(fromDate)) : null;
      const toDateClear = toDate ? clearTime(new Date(toDate)) : null;
      const isWithinDateRange =  (!fromDateClear || leadDate >= fromDateClear) &&  (!toDateClear || leadDate <= toDateClear);

    const isEmployeeMatch = !employeeId || userId == employeeId || leadassigned.userId == employeeId;

    return statusMatches && searchMatches && isWithinDateRange && isEmployeeMatch;
  }); 



const handleStatusChange = (event) => {
  setSelectedStatus(event.target.value); 
};

const handleChange = (event) => {
  setSelectedValue(event);
  if (event) {
    setIsEmployeeSelectedError(false); 
  }
};


  useEffect(() => {    
    const fetchLeadStatus =async()=>{
        try{
          const leadstatus = await LeadService.getAllLeadStatus();
          setLeadStatus(leadstatus);

        }catch(error){
          console.error('Error fetching lead status:', error);
        }
    }

    const fetchEmployee = async()=> {
      try {
        const users = await RegisterUserService.getEmployessByRoleId(4);
        setEmployees(users);
      } catch (error) { 
        console.error('Error fetching users:', error);  
        toastService.showError("Error", "Failed to fetch users data");
      }
    };

    fetchLeadStatus();
    fetchEmployee();

  }, [userId]);


  const LeadStatus = LEAD_STATUSES;
  const PropertyType = PROPERTY_TYPES;

  const handleLeadStatusChange = (event) => {
    setSelectedLeadStatus(event.target.value);
  };


  function getStatusClass(leadStatusName) {
    switch (leadStatusName) {
      case 'Interested':
        return 'table-success'; 
      case 'HotClient':
        return 'table-danger'; 
      case 'NotInterested':
        return 'table-info';   
      case 'CallBackLater':
        return 'table-warning'; 
      case 'InvalidNumber':
        return 'table-primary';
      case 'Complete':
        return 'table-primary';
        case 'Visited':
          return 'table-info';
          case 'UpcomingVisit':
            return 'table-warning';
      default:
        return ''; 
    }
  }

  const sourceTypes = [
    { id: 1, name: "Facebook" },
    { id: 2, name: "Instagram" },
    { id: 3, name: "Reference" },
  ];

  useEffect(() => {
    if (Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

//   const setReminder = (nextUpdate, followUpTime, leadName, leadCode, leadContactNumber) => {
  
//     const [hours, minutes] = followUpTime.split(':');
//     const followUpDateTime = new Date(`${nextUpdate}`);

//     const currentTime = new Date();
//     const timeDifference = followUpDateTime - currentTime;

//     // If time difference is positive, set a reminder
//     if (timeDifference > 0) {
//         setTimeout(() => {
//             if (Notification.permission === 'granted') {
//                 new Notification(`Follow up Reminder`, {
//                     body: `It's time to follow up with ${leadName}, ${leadCode}, ${leadContactNumber}!`,
//                 });
//               }
//             //  else {
//             //     alert(`It's time to follow up with ${leadName}!`);
//             // }
//         }, timeDifference);
//     }
// };


  const renderLeadsAssigned = () => {
    return filteredLeadsAssigned.map((leadassigned) => {

      const lead = leadassigned.lead;

      const sourceType = lead ? sourceTypes.find((source) => source.id === lead.sourceTypeId) : null;
      const sourceTypeName = sourceType ? sourceType.name : "Unknown";
  
      const leadStatus = LeadStatus.find((leadstatus) => leadstatus.id === leadassigned.leadStatusId);
      const leadStatusName = leadStatus ? leadStatus.name : "Unknown";

      const property = PropertyType.find((propertytype) => propertytype.id === leadassigned.propertyTypeId);
      const propertyTypeName = property ? property.name : "Unknown";

    
      const employee = employees.find((emp) => emp.id === leadassigned.userId);
      const employeeName = employee ? `${employee.firstName} ${employee.lastName}` : 'InActive Employee';
      
    //  setReminder(leadassigned.nextUpdate, leadassigned.followUpTime, lead ? lead.firstName : 'Unknown Lead', lead ? lead.leadCode : 'Unknown Lead', lead ? lead.contactNumber : 'Unknown Lead');

      return (
        <tr key={leadassigned.id}>

{(parseInt(userRole, 10) !== 4) && (
          <td>
          <input 
            type="checkbox" 
            checked={selectedRows.includes(leadassigned.leadId)}
            onChange={() => handleRowSelection(leadassigned.leadId)} />
          </td>
          )}
        
          <td>{lead ? `${lead.leadCode}` : 'Unknown Lead'}</td>
          <td>{lead ? `${lead.firstName}` : 'Unknown Lead'}</td>
          <td>{lead ? `${lead.email}` : 'Unknown Lead'}</td>
          <td>{lead ? `${lead.contactNumber}` : 'Unknown Lead'}</td>
          {/* <td>{sourceTypeName}</td> */}
          <td className={getStatusClass(leadStatusName)}> 
                {leadStatusName}
          </td>
          <td>{leadassigned.conversationComment}</td>
 
          <td>{propertyTypeName}</td> 
          <td>{lead ? `${lead.property}` : 'Unknown Lead'}</td> 
          <td>
            {new Date(leadassigned.leadAssignedDate).toLocaleDateString()}
          </td>
          <td>{employeeName}</td>
          <td>
              {new Date(leadassigned.followUpDate).toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: true,
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
              })}
          </td>

          <td>
              {new Date(leadassigned.nextUpdate).toLocaleString('en-US', {
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                  hour12: true,
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
              })}
          </td>
          <td>
            <button
              className="btn btn-outline-dark btn-sm"
              onClick={() => navigate(`/editleadassigned/${leadassigned.id}`)}
            >
              <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
            </button>
          </td>
        </tr>
      );
    });
  };

  
  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(LeadsAssigned.map(lead => lead.leadId)); 
    } else {
      setSelectedRows([]); 
    }
  };

  const handleRowSelection = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter(id => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };


  const ReAssignLead = async()=>{
    if (!selectedValue) {
      toastService.showWarning("Warning", "Please select an employee to re-assign the lead");
      return;
    }
    if (selectedRows.length === 0) {
      toastService.showWarning("Warning", "Please select at least one lead to re-assign");
      return;
    }
    
    try {
      await LeadsAssignedService.ReAssignedLeads(selectedValue, selectedRows);
        toastService.showSuccess("Success", "Lead Re-Assigned successfully");
    } catch (error) {
      toastService.showError("Error", "Failed to Assign lead");
    }
  }

  const showAdminBulkActions = parseInt(userRole, 10) !== 4;

  const displayFrom = fromDate instanceof Date && !isNaN(fromDate)
    ? fromDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : fromDateParam;
  const displayTo = toDate instanceof Date && !isNaN(toDate)
    ? toDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : toDateParam;

  const [search, setSearch] = React.useState('');

  const visibleLeads = filteredLeadsAssigned.filter((la) => {
    if (!search) return true;
    const q = search.toLowerCase();
    const lead = la.lead;
    return (
      (lead?.firstName || '').toLowerCase().includes(q) ||
      (lead?.contactNumber || '').toLowerCase().includes(q) ||
      (lead?.email || '').toLowerCase().includes(q) ||
      (lead?.leadCode || '').toLowerCase().includes(q) ||
      (la.conversationComment || '').toLowerCase().includes(q)
    );
  });


  return (
    <div style={{ padding: '20px', background: '#f4f6fb', minHeight: '100vh' }}>
      <Toast ref={toast} />
      <style>{`
        .fdl-row:hover{background:#f8f9fe!important}
        .fdl-editbtn:hover{background:#344767!important;color:#fff!important}
        .fdl-rbtn:hover{opacity:.88;transform:translateY(-1px)}
        .fdl-check{width:16px;height:16px;accent-color:#344767;cursor:pointer}
      `}</style>

      {/* ── Page header ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px', marginBottom: '18px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: 'linear-gradient(135deg,#5e72e4,#344767)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '18px', boxShadow: '0 4px 14px rgba(94,114,228,0.35)' }}>
            <i className="fas fa-clipboard-list" />
          </div>
          <div>
            <h5 style={{ margin: 0, fontWeight: '700', color: '#344767', fontSize: '18px' }}>Assigned Leads</h5>
            <p style={{ margin: 0, fontSize: '12px', color: '#8392ab' }}>
              <i className="fas fa-calendar-alt" style={{ marginRight: '5px' }} />
              {displayFrom} — {displayTo}
            </p>
          </div>
        </div>
        <button
          onClick={() => navigate(-1)}
          style={{ background: '#fff', border: '1.5px solid #e9ecef', borderRadius: '9px', padding: '8px 18px', color: '#344767', fontWeight: '600', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 6px rgba(52,71,103,0.07)' }}
        >
          <i className="fas fa-arrow-left" /> Back
        </button>
      </div>

      {/* ── Toolbar card ── */}
      <div style={{ background: '#fff', borderRadius: '14px', boxShadow: '0 2px 12px rgba(52,71,103,0.07)', padding: '14px 18px', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>

          {/* Search */}
          <div style={{ position: 'relative', flex: '1', minWidth: '200px' }}>
            <i className="fas fa-search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#8392ab', fontSize: '13px' }} />
            <input
              type="text"
              placeholder="Search name, phone, email, comment…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ paddingLeft: '34px', padding: '9px 12px 9px 34px', border: '1.5px solid #e9ecef', borderRadius: '9px', fontSize: '13px', color: '#344767', width: '100%', outline: 'none' }}
            />
          </div>

          {/* Status filter */}
          <select
            value={selectedStatus}
            onChange={handleStatusChange}
            style={{ padding: '9px 12px', border: '1.5px solid #e9ecef', borderRadius: '9px', fontSize: '13px', color: '#344767', background: '#fff', outline: 'none', minWidth: '160px', cursor: 'pointer' }}
          >
            <option value="">All Statuses</option>
            {LeadStatus.map((s) => (
              <option key={s.id} value={s.id}>{s.name}</option>
            ))}
          </select>

          {/* Count badge */}
          <span style={{ background: '#f0f2ff', color: '#5e72e4', borderRadius: '20px', padding: '5px 14px', fontSize: '12px', fontWeight: '700', whiteSpace: 'nowrap' }}>
            {visibleLeads.length} Record{visibleLeads.length !== 1 ? 's' : ''}
          </span>

          {/* Re-assign (admin/manager only) */}
          {showAdminBulkActions && (
            <>
              <select
                value={selectedValue}
                onChange={(e) => handleChange(e.target.value)}
                style={{ padding: '9px 12px', border: `1.5px solid ${isEmployeeSelectedError ? '#f5365c' : '#e9ecef'}`, borderRadius: '9px', fontSize: '13px', color: '#344767', background: '#fff', outline: 'none', minWidth: '200px', cursor: 'pointer' }}
              >
                <option value="" disabled>Select employee to re-assign…</option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>{emp.firstName} {emp.lastName}</option>
                ))}
              </select>
              {isEmployeeSelectedError && (
                <span style={{ color: '#f5365c', fontSize: '12px', fontWeight: '600' }}>
                  <i className="fas fa-exclamation-circle" style={{ marginRight: '4px' }} />Select an employee
                </span>
              )}
              {selectedRows.length > 0 && (
                <span style={{ background: '#344767', color: '#fff', borderRadius: '20px', padding: '5px 14px', fontSize: '12px', fontWeight: '700', whiteSpace: 'nowrap' }}>
                  {selectedRows.length} selected
                </span>
              )}
              <button
                className="fdl-rbtn"
                onClick={ReAssignLead}
                style={{ background: 'linear-gradient(135deg,#344767,#21243d)', border: 'none', borderRadius: '9px', padding: '9px 20px', color: '#fff', fontWeight: '600', fontSize: '13px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '7px', boxShadow: '0 4px 12px rgba(52,71,103,0.25)', transition: 'all .2s', whiteSpace: 'nowrap' }}
              >
                <MdRepeat size={14} /> Re-Assign
              </button>
            </>
          )}
        </div>
      </div>

      {/* ── Table ── */}
      <div style={{ background: '#fff', borderRadius: '14px', boxShadow: '0 2px 12px rgba(52,71,103,0.07)', overflow: 'hidden' }}>
        {visibleLeads.length === 0 ? (
          <div style={{ padding: '60px 20px', textAlign: 'center' }}>
            <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#f4f6fb', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '24px', color: '#c0c8d8' }}>
              <i className="fas fa-inbox" />
            </div>
            <p style={{ color: '#8392ab', fontWeight: '600', margin: 0 }}>No assigned leads found for the selected criteria</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f8f9fe', borderBottom: '2px solid #e9ecef' }}>
                  {showAdminBulkActions && (
                    <th style={{ padding: '12px 16px', width: '48px' }}>
                      <input
                        type="checkbox"
                        className="fdl-check"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                  )}
                  {['Lead','Contact','Status','Comment','Property','Assigned Date','Employee','Follow Up','Next Follow Up',''].map((h) => (
                    <th key={h} style={{ padding: '12px 16px', fontSize: '11px', fontWeight: '700', color: '#8392ab', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap', textAlign: h === '' ? 'center' : 'left' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {visibleLeads.map((la, idx) => {
                  const lead = la.lead;
                  const src = sourceTypes.find((s) => s.id === lead?.sourceTypeId);
                  const ls = LeadStatus.find((s) => s.id === la.leadStatusId);
                  const lsName = ls ? ls.name : 'Unknown';
                  const pt = PropertyType.find((p) => p.id === la.propertyTypeId);
                  const ptName = pt ? pt.name : '—';
                  const emp = employees.find((e) => e.id === la.userId);
                  const empName = emp ? `${emp.firstName} ${emp.lastName}` : 'Inactive Employee';
                  const sc = getStatusStyle(lsName);

                  return (
                    <tr
                      key={la.id}
                      className="fdl-row"
                      style={{ borderBottom: '1px solid #f0f2f5', background: idx % 2 === 0 ? '#fff' : '#fafbff', transition: 'background .15s' }}
                    >
                      {showAdminBulkActions && (
                        <td style={{ padding: '12px 16px' }}>
                          <input
                            type="checkbox"
                            className="fdl-check"
                            checked={selectedRows.includes(la.leadId)}
                            onChange={() => handleRowSelection(la.leadId)}
                          />
                        </td>
                      )}
                      {/* Lead name + code */}
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: 'linear-gradient(135deg,#344767,#5e72e4)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '13px', fontWeight: '700', flexShrink: 0 }}>
                            {(lead?.firstName || '?').charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <p style={{ margin: 0, fontWeight: '600', color: '#344767', fontSize: '13px' }}>{lead?.firstName || '—'}</p>
                            <span style={{ background: '#f0f2ff', color: '#5e72e4', borderRadius: '5px', padding: '1px 7px', fontSize: '10px', fontWeight: '700' }}>
                              {lead?.leadCode || '—'}
                            </span>
                          </div>
                        </div>
                      </td>
                      {/* Contact */}
                      <td style={{ padding: '12px 16px' }}>
                        <p style={{ margin: 0, fontSize: '12px', color: '#344767', fontWeight: '500' }}>
                          <i className="fas fa-phone" style={{ color: '#2dce89', marginRight: '5px', fontSize: '11px' }} />
                          {lead?.contactNumber || '—'}
                        </p>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#8392ab' }}>{lead?.email || '—'}</p>
                      </td>
                      {/* Status badge */}
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: sc.bg, color: sc.color, borderRadius: '20px', padding: '4px 12px', fontSize: '11px', fontWeight: '700', display: 'inline-flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                          <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: sc.dot, display: 'inline-block' }} />
                          {lsName}
                        </span>
                      </td>
                      {/* Comment */}
                      <td style={{ padding: '12px 16px', maxWidth: '160px' }}>
                        <p style={{ margin: 0, fontSize: '12px', color: '#525f7f', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {la.conversationComment || <span style={{ color: '#c0c8d8', fontStyle: 'italic' }}>No comment</span>}
                        </p>
                      </td>
                      {/* Property */}
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: '#f4f6fb', color: '#344767', borderRadius: '6px', padding: '3px 9px', fontSize: '11px', fontWeight: '600' }}>{ptName}</span>
                        {lead?.property && <p style={{ margin: '3px 0 0', fontSize: '11px', color: '#8392ab' }}>{lead.property}</p>}
                      </td>
                      {/* Assigned date */}
                      <td style={{ padding: '12px 16px', fontSize: '12px', color: '#8392ab', whiteSpace: 'nowrap' }}>
                        <i className="fas fa-calendar" style={{ marginRight: '5px', color: '#5e72e4' }} />
                        {new Date(la.leadAssignedDate).toLocaleDateString()}
                      </td>
                      {/* Employee */}
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#344767', fontWeight: '500' }}>
                          <i className="fas fa-user-circle" style={{ color: '#8392ab', fontSize: '14px' }} />
                          {empName}
                        </span>
                      </td>
                      {/* Follow up */}
                      <td style={{ padding: '12px 16px', fontSize: '11px', color: '#8392ab', whiteSpace: 'nowrap' }}>
                        <i className="fas fa-clock" style={{ marginRight: '4px', color: '#fb6340' }} />
                        {new Date(la.followUpDate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}
                      </td>
                      {/* Next follow up */}
                      <td style={{ padding: '12px 16px', fontSize: '11px', color: '#8392ab', whiteSpace: 'nowrap' }}>
                        <i className="fas fa-bell" style={{ marginRight: '4px', color: '#5e72e4' }} />
                        {new Date(la.nextUpdate).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}
                      </td>
                      {/* Edit */}
                      <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                        <button
                          className="fdl-editbtn"
                          onClick={() => navigate(`/editleadassigned/${la.id}`)}
                          style={{ background: 'transparent', border: '1.5px solid #344767', borderRadius: '8px', padding: '6px 12px', color: '#344767', fontSize: '12px', fontWeight: '600', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '5px', transition: 'all .2s' }}
                        >
                          <i className="fas fa-edit" /> Edit
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default FilterDataDashboardList;
